module.exports = __webpack_public_path__ + "img/practice.00e626b.png";